export const TYPE = {
    CONTENT: 0,
    POLICY: 1
};